// extracted by mini-css-extract-plugin
export default {"mainContain":"Settings_mainContain__72jBY","grid_container":"Settings_grid_container__SGfrU","heading":"Settings_heading__gLrUN","link":"Settings_link__zRgYk"};